<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="800" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Error Updating stock
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.pt-4.px-6.pb-0
      v-card.py-3.round-xl(outlined)
        template(v-for="(stock, index) in errorStocks")
          div(:key="`st-${index+1}`")
            v-divider.my-2(v-if="index")
            v-row.px-3(dense)
              v-col(cols="4")
                div.text-xs.neutral500--text Name
                div.text-sm.neutral700--text.my-1 {{ stock.stock.medicine.name }}
                div.text-xs.neutral500--text Total amount
                div.text-sm.neutral700--text.mt-1 {{ $currency.symbol }} {{ stock.stock.total }}
              v-col(cols="2")
                div.text-xs.neutral500--text Qty
                div.text-sm.neutral700--text.my-1 {{ stock.stock.quantity }}
                div.text-xs.neutral500--text Rate
                div.text-sm.neutral700--text.mt-1 {{ $currency.symbol }} {{ stock.stock.rate }}
              v-col(cols="3")
                div.text-xs.neutral500--text Batch no
                div.text-sm.neutral700--text.my-1 {{ stock.stock.batch_no || '-' }}
                div.text-xs.neutral500--text Exp date
                div.text-sm.neutral700--text.mt-1 {{ stock.stock.expiryDateField || '-'  }}
              v-col(cols="3")
                template(v-if="stock.updateSuccessful")
                  div.text-xs.neutral500--text Stock update status
                  y-chip.mt-1(label="successful" color="green" size="sm" outlined)
                    template(#append)
                      v-icon.ml-1(size=15 color="success600") $yzi-check-circle
                template(v-else)
                  div.text-xs.neutral500--text Error details
                  div.text-sm.danger500--text.my-1 {{ stock.message }}
                  y-button( label="Retry stock update" size="xs" outlined :loading="isLoading" @click="retryUpdate(stock)")
                

    v-card-actions.py-4.px-6
      v-spacer
      y-button(label="Close" color="danger500" size="md" dark :loading="isLoading" @click="closeDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stocks: {
      type: Array,
      default: (() => [])
    },
    invoice: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      isLoading: false,
      errorStocks: [],
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.errorStocks = this.stocks
  },
  methods: {
    ...mapActions(['showMessage']),
    retryUpdate (stock) {
      this.isLoading = true
      let data = {
        action: 'received',
        change: stock.stock.quantity,
        cost: Math.round(Number(stock.stock.total) * Number(this.$currency.multiplier))
      }
      if (stock.stock.batch_no) { data.batch_no = stock.stock.batch_no }
      if (stock.stock.expiryDateField) { data.expiry_date = stock.stock.selectedExpiryDate }
      this.$axios.post(`/products/${stock.stock.medicine.product.id}/inventories`, data)
        .then(resp => {
          stock.updateSuccessful = true
          let id = resp.data.id
          if (this.invoice && this.invoice.id) {
            const payload = {
              product_inventory_id: id
            }
            this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/${this.invoice.id}/items/`, payload)
              .catch(() => {
                this.showMessage(['error', 'Error adding item to the selected invoice'])
              })
          }
        })
        .catch(err => {
          let message = 'Error updating stock'
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
          stock.message = message
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>